import { createMove, Flag, formatSquare, PieceChar } from "@chessalpha/core";
export const uciToMove = (position, uciMove) => {
    const from = formatSquare(uciMove.substring(0, 2));
    const to = formatSquare(uciMove.substring(2, 4));
    const promote = uciMove[4] === PieceChar.n
        ? Flag.PromoteKnight
        : uciMove[4] === PieceChar.b
            ? Flag.PromoteBishop
            : uciMove[4] === PieceChar.r
                ? Flag.PromoteRook
                : uciMove[4] === PieceChar.q
                    ? Flag.PromoteQueen
                    : undefined;
    return createMove(position, from, to, promote);
};
//# sourceMappingURL=uciToMove.js.map